import { isPerSqmMetric } from "../../cubeDataTable/utils/derivedUtils";
import { UNSTACKABLE_METRICS } from "./graphConstants";

/**
 * Line dash patterns by year offset.
 * 0 = current fiscal year (solid), -1/-2 = dashed, older = dotted.
 */
export function getLineDash(yearOffset: number): number[] {
  if (yearOffset === 0) return [];
  if (yearOffset === -1 || yearOffset === -2) return [6, 3];
  return [2, 2];
}

/**
 * STORE_SQM and STORE_COUNT are store-level metrics not decomposable by dimension.
 * PER_SQM metrics are derived and don't aggregate correctly when split.
 */
export function isStackableMetric(metricName: string): boolean {
  return !UNSTACKABLE_METRICS.has(metricName) && !isPerSqmMetric(metricName);
}
